import React, { useEffect, useState } from 'react';
import { testimonialApi } from '../services/api';

const fallbackTestimonials = [
  {
    id: 1,
    name: 'Ananya M.',
    role: 'Verified Client • Anxiety & Stress',
    rating: 5,
    text: 'Finding a therapist who truly understands my anxiety felt overwhelming until I found PsychMitra. The direct booking with zero commission markup meant honest pricing and complete peace of mind.',
    location: 'Mumbai'
  },
  {
    id: 2,
    name: 'Dr. Rohit Mehta',
    role: 'Clinical Psychologist • Verified Practitioner',
    rating: 5,
    text: 'PsychMitra gives practitioners genuine autonomy. Keeping 100% of my session fees while having integrated tools for scheduling, session notes, and workshops has elevated my practice.',
    location: 'Bangalore'
  },
  {
    id: 3,
    name: 'Priya & Kabir S.',
    role: 'Couples Therapy • Relationship Wellness',
    rating: 5,
    text: 'Our couples therapy journey through PsychMitra was life-changing. Detailed therapist bios and verified credentials helped us find the perfect match with total confidence.',
    location: 'Delhi NCR'
  },
  {
    id: 4,
    name: 'Meera N.',
    role: 'Wellness Member • Student',
    rating: 5,
    text: 'The self-help resources, workshop access, and empathetic community make PsychMitra much more than a booking directory — it is a genuine mental wellness companion.',
    location: 'Pune'
  }
];

function TestimonialsSection() {
  const [testimonials, setTestimonials] = useState(fallbackTestimonials);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const data = await testimonialApi.getTestimonials();
        const list = data?.testimonials || data?.data || (Array.isArray(data) ? data : []);
        if (Array.isArray(list) && list.length > 0) {
          const mapped = list.map((item, idx) => ({
            id: item._id || idx,
            name: item.name || 'Verified Member',
            role: item.role || 'PsychMitra Member',
            rating: item.rating || 5,
            text: item.text || item.comment || 'PsychMitra provided an empowering therapy experience.',
            location: item.location || '',
            avatar: item.avatar || ''
          }));
          setTestimonials(mapped);
        }
      } catch (err) {
        console.error('Error loading testimonials from database:', err);
      }
    };

    fetchTestimonials();
  }, []);

  // Auto slide rotation every 7 seconds
  useEffect(() => {
    if (testimonials.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const current = testimonials[currentIndex] || fallbackTestimonials[0];

  return (
    <section className="testimonial-one" style={{ position: 'relative', overflow: 'hidden' }}>
      <div className="container">
        <div className="row align-items-center">
          {/* Section Left Title */}
          <div className="col-xl-4 col-lg-5 mb-4 mb-lg-0">
            <div className="testimonial-one__left">
              <div className="section-title text-left">
                <span
                  style={{
                    color: '#7c4bb9',
                    fontSize: '13px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    textTransform: 'uppercase',
                    display: 'block',
                    marginBottom: '8px'
                  }}
                >
                  WHAT OTHERS SAY
                </span>
                <h2 className="section-title__title" style={{ fontSize: '36px', lineHeight: '1.25' }}>
                  Real People, <span style={{ color: '#7c4bb9' }}>Real Stories</span>
                </h2>
                {/* <p style={{ marginTop: '14px', color: '#666666', fontSize: '15px', lineHeight: '1.6' }}>
                  Read genuine experiences from individuals, couples, and mental health practitioners across our platform.
                </p> */}
              </div>

              {/* Navigation Controls */}
              <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
                <button
                  type="button"
                  onClick={handlePrev}
                  aria-label="Previous testimonial"
                  style={{
                    width: '46px',
                    height: '46px',
                    borderRadius: '50%',
                    backgroundColor: '#ffffff',
                    border: '1.5px solid #ece5f8',
                    color: '#5b2d99',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '15px',
                    boxShadow: '0 4px 12px rgba(124, 75, 185, 0.08)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#7c4bb9';
                    e.currentTarget.style.color = '#ffffff';
                    e.currentTarget.style.borderColor = '#7c4bb9';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#ffffff';
                    e.currentTarget.style.color = '#5b2d99';
                    e.currentTarget.style.borderColor = '#ece5f8';
                  }}
                >
                  <i className="fas fa-chevron-left"></i>
                </button>
                <button
                  type="button"
                  onClick={handleNext}
                  aria-label="Next testimonial"
                  style={{
                    width: '46px',
                    height: '46px',
                    borderRadius: '50%',
                    backgroundColor: '#ffffff',
                    border: '1.5px solid #ece5f8',
                    color: '#5b2d99',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '15px',
                    boxShadow: '0 4px 12px rgba(124, 75, 185, 0.08)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#7c4bb9';
                    e.currentTarget.style.color = '#ffffff';
                    e.currentTarget.style.borderColor = '#7c4bb9';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#ffffff';
                    e.currentTarget.style.color = '#5b2d99';
                    e.currentTarget.style.borderColor = '#ece5f8';
                  }}
                >
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Section Right Dynamic Testimonial Card */}
          <div className="col-xl-8 col-lg-7">
            <div className="testimonial-one__right">
              <div
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '24px',
                  padding: '40px 45px',
                  boxShadow: '0 15px 40px rgba(124, 75, 185, 0.1)',
                  border: '1.5px solid #ece5f8',
                  position: 'relative',
                  minHeight: '260px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  transition: 'opacity 0.4s ease'
                }}
              >
                {/* Large Decorative Quote Icon */}
                <div
                  style={{
                    position: 'absolute',
                    top: '25px',
                    right: '30px',
                    fontSize: '44px',
                    color: 'rgba(124, 75, 185, 0.15)',
                    lineHeight: 1
                  }}
                >
                  <i className="fas fa-quote-right"></i>
                </div>

                {/* Rating Stars */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '16px' }}>
                  {[...Array(current.rating || 5)].map((_, i) => (
                    <i key={i} className="fas fa-star" style={{ color: '#f39c12', fontSize: '15px' }}></i>
                  ))}
                  <span style={{ fontSize: '13px', fontWeight: 700, color: '#7c4bb9', marginLeft: '8px' }}>
                    {current.rating ? `${current.rating}.0` : '5.0'} / 5.0
                  </span>
                </div>

                {/* Testimonial Quote Text */}
                <p
                  style={{
                    fontSize: '17px',
                    lineHeight: '1.75',
                    color: '#444444',
                    fontStyle: 'normal',
                    margin: '0 0 24px 0',
                    fontWeight: 500,
                    position: 'relative',
                    zIndex: 1
                  }}
                >
                  &ldquo;{current.text}&rdquo;
                </p>

                {/* Client Info Row */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px solid #f0eaf8', paddingTop: '18px', flexWrap: 'wrap', gap: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <div
                      style={{
                        width: '46px',
                        height: '46px',
                        borderRadius: '50%',
                        backgroundColor: '#f0e9ff',
                        color: '#7c4bb9',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 800,
                        fontSize: '18px',
                        boxShadow: '0 4px 10px rgba(124, 75, 185, 0.12)'
                      }}
                    >
                      {current.name.charAt(0)}
                    </div>
                    <div>
                      <h4 style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: '#2c194d' }}>
                        {current.name}
                      </h4>
                      <span style={{ fontSize: '13px', color: '#7c4bb9', fontWeight: 600 }}>
                        {current.role}
                      </span>
                    </div>
                  </div>

                  {/* Indicator dots */}
                  <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                    {testimonials.map((_, dotIdx) => (
                      <button
                        key={dotIdx}
                        type="button"
                        onClick={() => setCurrentIndex(dotIdx)}
                        aria-label={`Go to slide ${dotIdx + 1}`}
                        style={{
                          width: currentIndex === dotIdx ? '22px' : '8px',
                          height: '8px',
                          borderRadius: '4px',
                          backgroundColor: currentIndex === dotIdx ? '#7c4bb9' : '#e0d4f5',
                          border: 'none',
                          padding: 0,
                          cursor: 'pointer',
                          transition: 'all 0.3s ease'
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
